import {extractCSPNonce} from '../../shared/extractCspNonce';

const injectScript = (
  SCRIPT: string,
  callback: () => unknown,
  onError: OnErrorEventHandler,
) => {
  const script = document.createElement('script');
  script.src = SCRIPT;
  script.onload = callback;
  script.onerror = onError;

  // https://developer.paypal.com/reference/guidelines/browser-support/#content-security-policy-rules
  const nonce = extractCSPNonce('script');
  if (nonce) {
    script.setAttribute('data-csp-nonce', nonce);
  }
  document.body && document.body.appendChild(script);
};

export default injectScript;
